var initSlider = function initSlider() {
  new Swiper('.product-recommendations__slider', {
    slidesPerView: 'auto',
    spaceBetween: 20,
    breakpoints: {
      992: {
        autoplay: false,
        slidesPerView: 3
      }
    }
  });
};
var initProductRecommendations = function initProductRecommendations() {
  var relatedProducts = document.querySelector('.product-recommendations');
  if (!relatedProducts) {
    return;
  }
  var handleIntersection = function handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(productRecommendationsSection);
    var url = productRecommendationsSection.dataset.url;
    fetch(url).then(function (response) {
      return response.text();
    }).then(function (text) {
      var html = document.createElement('div');
      html.innerHTML = text;
      var recommendations = html.querySelector('.product-recommendations');
      if (recommendations && recommendations.innerHTML.trim().length) {
        productRecommendationsSection.innerHTML = recommendations.innerHTML;
        initSlider();
      }
    })["catch"](function (e) {
      console.error(e);
    });
  };
  var productRecommendationsSection = document.querySelector('.product-recommendations');
  var observer = new IntersectionObserver(handleIntersection, {
    rootMargin: '0px 0px 200px 0px'
  });
  observer.observe(productRecommendationsSection);
};
export { initProductRecommendations };